"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Gtm = void 0;
var _analyticsState = require("./analytics-state");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Internal module for initializing Snowplow and making Snowplow-specific event calls. Public init functions can be found in Initializer module
 * @module Gtm
 */
var Gtm = exports.Gtm = /*#__PURE__*/function () {
  function Gtm() {
    _classCallCheck(this, Gtm);
  }
  return _createClass(Gtm, null, [{
    key: "initialize",
    value:
    /**
     * Initializes Google Tag Manager
     * @function initialize
     */
    function initialize(writeKey) {
      var containerId = Gtm.getContainerId(writeKey);
      if (containerId) {
        var _firstScript$parentNo;
        window['dataLayer'] = window['dataLayer'] || [];
        window['dataLayer'].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        });
        var firstScript = document.getElementsByTagName('script')[0];
        var gtmScript = document.createElement('script');
        gtmScript.async = true;
        gtmScript.src = 'https://www.googletagmanager.com/gtm.js?id=' + containerId;
        firstScript === null || firstScript === void 0 || (_firstScript$parentNo = firstScript.parentNode) === null || _firstScript$parentNo === void 0 || _firstScript$parentNo.insertBefore(gtmScript, firstScript);
      }
    }

    /**
     * Sends a gtm page call
     * @function page
     */
  }, {
    key: "page",
    value: function page(name, category, data) {
      var event = 'Loaded a Page';
      Gtm.track(data, event);
      if (category) {
        event = 'Viewed ' + name + ' ' + category + ' Page';
        Gtm.track(data, event);
      }
      if (name) {
        event = 'Viewed ' + name + ' Page';
        Gtm.track(data, event);
      }
    }
  }, {
    key: "track",
    value: function track(data, event) {
      var props = typeof data !== 'undefined' ? JSON.parse(JSON.stringify(data)) : {};
      var anonId = _analyticsState.AnalyticsState.anonymousId;
      if (anonId) {
        props.gasv3AnonymousId = anonId;
      }
      if (event) {
        props.event = event;
      }
      var dataLayer = 'dataLayer';
      window[dataLayer] = window[dataLayer] || [];
      window[dataLayer].push(props);
    }
  }, {
    key: "getContainerId",
    value: function getContainerId(writeKey) {
      var containerIds = Gtm.getContainerIdMapping();
      return containerIds[writeKey];
    }
  }, {
    key: "getContainerIdMapping",
    value: function getContainerIdMapping() {
      return {
        // Production
        ycih1ygfsk: 'GTM-MR6PJQR',
        // support.atlassian.com
        '9nfqb81km3': 'GTM-TSGXFNC',
        // confluence.atlassian.com
        kFTUHPhH9Q: 'GTM-TRS3MV',
        // bitbucket
        u7y09b0olq: 'GTM-5VS67RK',
        // developer.atlassian.com
        eNVsl3NOQquS5E0YXjD4prfiNVqVP3mr: 'GTM-KZLJPX4',
        // opsgenie
        bvsetm1g1y: 'GTM-5RJSBR',
        // atlassian.com-cart
        kiv6wyh2nw: 'GTM-5RJSBR',
        // atlassian.com
        r4n974s99s: 'GTM-5RJSBR',
        // blogs.atlassian.com
        swoogo: 'GTM-5RJSBR',
        // events.atlassian.com
        '8oi64no': 'GTM-K7MDT22',
        // statuspage.io
        xjtlog1hqa: 'GTM-KQ6R2C3',
        // marketplace.atlassian.com
        bNSPpYAL9OiAkamBRvfRJoRu9YANW14I: 'GTM-MGV77B',
        // docs.atlassian.com-aui
        TNnhg0QuQfHEpBTzp27kJXNWZoMqSvkw: 'GTM-TQZMFCL',
        // community.atlassian.com
        trello: 'GTM-PJ8M5SK',
        // trello

        // Test
        '4J6H7c3XTcpm1dbenkOILSyOachvf9It': 'GTM-TQZMFCL',
        // community.stg.atlassian.com
        SBLZG3ZYcSBcUMeLKLalrtyW8w1Caold: 'GTM-TQZMFCL',
        // community.dev1.dev.atlassian.com
        QVFu18jjHlCNaBXizZ3mtiqlBXVRkg1M: 'GTM-TQZMFCL',
        // community.dev2.dev.atlassian.com
        QmWM6iw7auEJw5gDQi6910Xk1wqyZ6bE: 'GTM-TQZMFCL',
        // community.dev3.dev.atlassian.com
        hWTszOAQMuItRdv8J30A3mNpCWd891bx: 'GTM-TQZMFCL',
        // community.dev4.dev.atlassian.com
        EWfeqJKJ0rPNOe3fcXrh2dg7bVXZNi2I: 'GTM-5RJSBR',
        // qa-wac.internal.atlassian.com
        Z2S07IGcRYkPJ7XHy3OIXcjpYoy9E6bs: 'GTM-5RJSBR' // CXP Local Dev
      };
    }
  }]);
}();